import axios from "axios";

const state = () => ({
  devices: [],
  course_devices: [],
  bulkUploadData: {},
  recordsFiltered: 0,
  recordsTotal: 0,
  device_query: {
    draw: 0,
    start: 0,
    length: 10,
    search: "",
    orderBy: "id",
    dir: "asc",
  },
  current_page: 1,
  last_page: 1,
  per_page: 5,
  total: 0,
  errors: [],
  loading: false,
  message: "",
  logs: "",
  actions: {
    logs: { action: "send-logs", limit: 5000 },
    config: { action: "get-config" },
    courses: { action: "get-courses" },
    advertisments: { actions: "get-advertisements" },
    register: { action: "re-register", unit: 1, type: 1 },
  },
});

const mutations = {
  SET_DEVICES(state, devices) {
    state.devices = devices;
  },
  SET_COURSE_DEVICES(state, devices) {
    state.course_devices = devices;
  },
  SET_DEVICES_PARAMS(state, params) {
    state.recordsFiltered = params.recordsFiltered;
    state.recordsTotal = params.recordsTotal;
  },
  SET_RECORDS(state, records) {
    state.recordsFiltered = records.filtered;
    state.recordsTotal = records.total;
  },
  SET_DEVICE_QUERY(state, query) {
    state.device_query = query;
  },
  RESET_DEVICE_QUERY(state) {
    state.device_query = {
      draw: 0,
      start: 0,
      length: 10,
      search: "",
      orderBy: "id",
      dir: "asc",
      filterApplied: false,
    };
    state.recordsFiltered = 0;
    state.recordsTotal = 0;
    state.devices = [];
  },
  SET_BULK_UPLOAD_DATA(state, data) {
    state.bulkUploadData = data;
  },
  SET_CURRENT_PAGE(state, page) {
    state.current_page = page;
  },
  SET_LAST_PAGE(state, page) {
    state.last_page = page;
  },
  SET_PER_PAGE(state, per_page) {
    state.per_page = per_page;
  },
  SET_TOTAL(state, total) {
    state.total = total;
  },
  SET_ERRORS(state, errors) {
    state.errors = errors;
  },
  SET_LOADING(state) {
    state.loading = true;
  },
  CLEAR_LOADING(state) {
    state.loading = false;
  },
  SET_DEVICE_LOGS(state, logs) {
    state.logs = logs;
  },
};

const getters = {
  getDevices: (state) => {
    return state.devices;
  },
  getCourseDevices: (state) => {
    return state.course_devices;
  },
  getRecordsFiltered: (state) => {
    return state.recordsFiltered;
  },
  getRecordsTotal: (state) => {
    return state.recordsTotal;
  },
  getDeviceQuery: (state) => {
    return state.device_query;
  },
  getDevicesParams: (state) => {
    return state.devicesParams;
  },
  getbulkUploadData: (state) => {
    return state.bulkUploadData;
  },
  getCurrentPage: (state) => {
    return state.current_page;
  },
  getPerPage: (state) => {
    return state.per_page;
  },
  getTotal: (state) => {
    return state.total;
  },
  isLoading: (state) => {
    return state.loading;
  },
};

const actions = {
  async fetchWindtagDevices({ commit, state }) {
    commit("SET_LOADING");
    const url = process.env.VUE_APP_API_URL + "/windtagDevices/filter-devices";

    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
      },
    };

    try {
      const response = await axios.post(url, state.device_query, config);
      commit("SET_DEVICES", response.data.data);
      commit("SET_DEVICES_PARAMS", response.data);
      commit("CLEAR_LOADING");
      return response.data;
    } catch (error) {
      commit("CLEAR_LOADING");
      console.error(error);
      throw error?.response?.data;
    }
  },

  async uploadBulkWindtagDevices({ commit, dispatch }, payload) {
    const url =
      process.env.VUE_APP_API_URL + "/windtagDevices/bulk-devices-upload";

    const formData = new FormData();
    formData.append("uploaded_file", payload);

    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
        "Content-Type": "multipart/form-data",
      },
    };

    try {
      const response = await axios.post(url, formData, config);
      const messages = [];

      if (
        Array.isArray(response.data.updated) &&
        response.data.updated.length
      ) {
        messages.push(
          `Updated (${response.data.updated.length}):`,
          ...response.data.updated.map(
            (item) =>
              `TAG: ${item.tag} | MAC: ${item.mac} | CLASS: ${
                item.windtag_device_class
              } | ${item.info || "Updated"}`
          )
        );
      }

      if (Array.isArray(response.data.errors) && response.data.errors.length) {
        messages.push(`Errors (${response.data.errors.length}):`);
        messages.push(
          ...response.data.errors.map((err) => {
            const base = `TAG: ${err.tag} | MAC: ${err.mac} | CLASS: ${
              err.windtag_device_class
            }\n${err.error ? "ERROR: " + err.error : ""}`;
            return err.info ? `${base} | ERROR: ${err.info}` : base;
          })
        );
      }

      const formattedMessage = messages.length ? messages.join("\n\n") : "";
      response.data.formatted_message = formattedMessage;

      commit("SET_BULK_UPLOAD_DATA", response.data);
      dispatch("fetchWindtagDevices");

      dispatch(
        "toastNotification/displayToast",
        {
          message: response.data.message,
          type: messages.length ? "info" : "success",
        },
        { root: true }
      );
      return response.data;
    } catch (error) {
      commit("SET_DEVICES", {});
      if (error?.msg) {
        throw error;
      } else {
        throw error?.response?.data;
      }
    }
  },

  async addWindtagDevice({ dispatch }, payload) {
    const url = process.env.VUE_APP_API_URL + "/windtagDevices/add-device";

    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
      },
    };

    try {
      await axios.post(url, payload, config);

      dispatch("fetchWindtagDevices");
    } catch (error) {
      if (error?.msg) {
        throw error;
      } else {
        throw error?.response?.data;
      }
    }
  },

  async archiveWindtagDevices({ commit, dispatch }, payload) {
    const url = process.env.VUE_APP_API_URL + "/windtagDevices/delete-devices";

    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
      },
      data: payload,
    };

    try {
      const response = await axios.delete(url, config);
      dispatch("fetchWindtagDevices");
      if (response?.data?.errors?.length > 0) {
        commit(
          "toastNotification/SET_MODAL",
          {
            title: "Archive devices",
            message: `${response.data.errors.join("\n ")}`,
            type: "warning",
          },
          { root: true }
        );
      }
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async unassignWindtagDevices({ commit, dispatch }, payload) {
    const url =
      process.env.VUE_APP_API_URL + "/windtagDevices/unassign-devices";

    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
      },
      data: payload,
    };
    try {
      const response = await axios.delete(url, config);
      dispatch("fetchWindtagDevices");
      if (response?.data?.errors?.length > 0) {
        commit(
          "toastNotification/SET_MODAL",
          {
            title: "Unassign devices",
            message: `${response.data.errors.join("\n ")}`,
            type: "warning",
          },
          { root: true }
        );
      }
      if (response?.not_found_macs?.length > 0) {
        dispatch(
          "toastNotification/displayToast",
          {
            message:
              `Some devices could not be unassigned because they were not found: \n\n` +
              response.not_found_macs
                .map((not_found_macs) => `MAC:${not_found_macs}`)
                .join("\n"),
            type: "error",
            duration: 10000,
          },
          { root: true }
        );
      } else if (response?.data?.devices_not_in_course?.length > 0) {
        dispatch(
          "toastNotification/displayToast",
          {
            message:
              `Some devices could not be unassigned because they are not assigned to a course: ` +
              response?.data?.devices_not_in_course
                .map((devices_not_in_course) => `MAC:${devices_not_in_course}`)
                .join(" "),
            type: "warning",
            duration: 10000,
          },
          { root: true }
        );
      } else if (response?.data?.unassigned_macs?.length > 0) {
        dispatch(
          "toastNotification/displayToast",
          {
            message: response?.data?.message,
            type: "success",
          },
          { root: true }
        );
      }
    } catch (error) {
      console.error(error);
      throw error.response.data;
    }
  },

  async updateWindtagDevice({ dispatch }, payload) {
    const url = process.env.VUE_APP_API_URL + "/windtagDevices/update-device";
    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
      },
    };

    const modifiedPayload = { ...payload };

    if ("windtag_device_class_id" in modifiedPayload) {
      modifiedPayload.windtag_device_class_id =
        modifiedPayload.windtag_device_class;
      delete modifiedPayload.windtag_device_class;
    }

    console.log("Debug-updateWindtagDevice-payload:", modifiedPayload);
    try {
      const response = await axios.patch(url, modifiedPayload, config);
      if (response.status === false) {
        throw response.data;
      }
      dispatch("fetchWindtagDevices");
    } catch (error) {
      throw error?.response?.data;
    }
  },

  async moveWindtagDevices({ commit, dispatch }, payload) {
    const url = process.env.VUE_APP_API_URL + "/windtagDevices/move-devices";

    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
      },
    };

    try {
      const response = await axios.patch(url, payload, config);
      if (response.status === false) {
        throw response.data;
      }

      await dispatch("fetchWindtagDevices");
      if (response?.data?.errors?.length > 0) {
        commit(
          "toastNotification/SET_MODAL",
          {
            title: "Move devices",
            message: `${response.data.errors.join("\n ")}`,
            type: "warning",
          },
          { root: true }
        );
      }
      if (response?.data?.message) {
        dispatch(
          "toastNotification/displayToast",
          {
            message: response.data.message,
            type: "success",
          },
          { root: true }
        );
      }
      return response.data;
    } catch (error) {
      throw error?.response?.data;
    }
  },

  async exportDevicesCSV({ commit, state }) {
    commit("SET_LOADING");
    const url = process.env.VUE_APP_API_URL + "/devices/export";

    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
      },
    };

    try {
      const response = await axios.post(url, state.device_query, config);
      const blob = new Blob([response.data], { type: "text/csv" });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", "Central_devices_export.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      commit("CLEAR_LOADING");
      return response.data;
    } catch (error) {
      commit("CLEAR_LOADING");
      console.log(error);
      throw error?.response?.data;
    }
  },

  setDeviceQuery({ commit }, payload) {
    commit("SET_DEVICE_QUERY", payload);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
